import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "cover",       // The wrapper for a whole cover row
    "color",       // The wrapper for an individual color
    "coverInfo",   // The hidden string containing the cover's searchable text
    "searchInput", // The search bar
    "gradeFilter", // The checkboxes for grades
    "top25Filter"  // The checkbox for Top 25
  ]

  connect() {
    // Run the filters immediately on load to respect default checked states
    this.applyFilters()
  }


  // Any time a checkbox is clicked or typing happens, this ONE function runs
  applyFilters() {
    // 1. Get Search Query
    const query = this.hasSearchInputTarget ? this.searchInputTarget.value.toLowerCase().trim() : ""

    // 2. Get Checked Grades
    const activeGrades = this.gradeFilterTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.filterId)

    // 3. Get Top 25 Status
    const showOnlyTop25 = this.hasTop25FilterTarget ? this.top25FilterTarget.checked : false

    // 4. Loop over every cover and apply the logic
    this.coverTargets.forEach(cover => {

      // -- CHECKBOX LOGIC --
      const coverGrade = cover.dataset.grade
      console.log(coverGrade)
      const passesGrade = activeGrades.includes(coverGrade)
console.log(passesGrade)
      const coverTop25 = cover.dataset.top25
      const passesTop25 = showOnlyTop25 ? (coverTop25 !== "none") : true

      // If it fails the checkboxes, hide the cover entirely and skip search logic
      if (!passesGrade || !passesTop25) {
        this.toggleVisibility(cover, true)
        return
      }

      // -- SEARCH LOGIC --
      const coverInfoText = this.getCoverInfoText(cover)
      const isCoverTextMatch = query === "" || coverInfoText.includes(query)

      const colors = cover.querySelectorAll('[data-cover-display-target="color"]')
      let visibleColorsCount = 0

      colors.forEach(color => {
        console.log(color)
        const colorText = color.textContent.toLowerCase()
        const isColorTextMatch = query === "" || colorText.includes(query)
        console.log(isColorTextMatch)
        // Show color if the cover matches OR the color itself matches
        if (isCoverTextMatch || isColorTextMatch) {
          this.toggleVisibility(color, false)
          visibleColorsCount++
        } else {
          this.toggleVisibility(color, true)
        }
      })

      // -- FINAL VISIBILITY --
      // If a cover ends up with 0 visible colors, hide the entire cover.
      this.toggleVisibility(cover, visibleColorsCount === 0)
    })
  }

  getCoverInfoText(cover) {
    const infoTarget = cover.querySelector('[data-cover-display-target="coverInfo"]')
    return infoTarget ? infoTarget.textContent.toLowerCase() : ""
  }

  toggleVisibility(element, shouldHide) {
    element.hidden = shouldHide
    element.classList.toggle('hidden', shouldHide)
  }
}
